"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRoundTitle = void 0;
const lodash_1 = require("lodash");
const enums_1 = require("../../tournament/enums");
const constants_1 = require("../constants");
const enums_2 = require("../enums");
const generateRoundTitle = (rounds, roundGroupId, roundNumber, type) => {
    var _a, _b;
    if (!(rounds === null || rounds === void 0 ? void 0 : rounds.length) || typeof roundNumber !== 'number') {
        return '';
    }
    if (roundGroupId === 2) {
        return 'Grand Final';
    }
    const roundGroups = (0, lodash_1.groupBy)(rounds, 'group_id');
    const groupRoundsCount = (_b = (_a = roundGroups[roundGroupId]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    const isDoubleElimination = type === enums_1.TournamentType.DoubleEliminationTournament;
    const groupPrefixes = isDoubleElimination
        ? { 0: enums_2.TournamentDoubleEliminationGroupTitle.Upper, 1: enums_2.TournamentDoubleEliminationGroupTitle.Lower }
        : { 0: '' };
    const prefix = isDoubleElimination ? `${groupPrefixes[roundGroupId]} ` : '';
    const roundIndex = roundNumber - 1;
    if (roundIndex < 1) {
        return `${prefix}Round ${roundNumber}`;
    }
    if (groupRoundsCount > 4 && roundIndex === groupRoundsCount - constants_1.QUARTER_FINALS_END_POSITION) {
        return `${prefix}Quarter Finals`;
    }
    if (groupRoundsCount > 3 && roundIndex === groupRoundsCount - constants_1.SEMI_FINALS_END_POSITION) {
        return `${prefix}Semi-Finals`;
    }
    if (roundIndex === groupRoundsCount - constants_1.FINALS_END_POSITION) {
        return `${prefix}Finals`;
    }
    if (roundIndex === groupRoundsCount) {
        return 'Champion';
    }
    return `${prefix}Round ${roundNumber}`;
};
exports.generateRoundTitle = generateRoundTitle;
//# sourceMappingURL=generate-round-title.js.map